import { jsx as _jsx } from "react/jsx-runtime";
import { CSSTransition } from "react-transition-group";
import * as S from "./SwitchFlickerAnimation.styles";
var SwitchFlickerAnimation = function (props) {
    return (_jsx(S.Wrap, { children: _jsx(CSSTransition, { in: props.value, timeout: 4000, classNames: "fade-in-condition", children: props.children }) }));
};
// eslint-disable-next-line import/no-default-export
export default SwitchFlickerAnimation;
